import React from 'react'
import Shadeddiv from '../Components/Shadeddiv'
import Cvbtn from '../Components/Cvbtn'
const About = () => {
  return (
    <div className='bg-aboutbg w-screen relative min-h-screen h-max flex flex-col  justify-evenly items-center  ' id='about'>
      {/* shaded div &&main heading {/*border-2 border-red*/}
       <Shadeddiv shadedtext={"About me"}  underlinetext1={"know"} underlinetext2={"me"} underlinetext3={"more"} /> 
     {/************* myself starts here bg-yellow-700************ */}
     <div className='flex ml-56 w-3/4 lg:ml-0 gap-1  h-fit items-baseline p-3 justify-between md:flex-col md:items-center mb-4 md:gap-6 flex-wrap lg:w-screen'>
      {/* name bg-slate-600 */}
      <div className='flex flex-col w-2/4   lg:w-full  ' >
        <p className='capitalize block text-white text-3xl   md:text-3xl esm:text-xl md:w-full  ' >
        i'm <span className='capitalize text-red'>hardik chopra</span>,a web developer  
        </p>
        <p className=' mt-6 lg:mt-2 esm:mt-1  sm:text-xl text-abouttext capitalize mb-6 lg:mb-1 '>
        i can help you build brand for your business at an affordable price.Throughout my journey as a frontend developer, I have developed a deep understanding of modern web development practices and frameworks. From responsive design and CSS frameworks like Bootstrap and Tailwind CSS to JavaScript libraries and frameworks like React, I enjoy staying up-to-date with the latest trends and technologies.
        </p>
        <p className='text-abouttext sm:text-xl'>
        Collaboration is at the heart of my work. I thrive in team environments where I can actively engage with designers, backend developers, and other stakeholders to transform concepts and wireframes into intuitive and immersive user experiences. Through effective communication and a collaborative mindset, I contribute to delivering projects on time and exceeding client expectations. 
        </p>
      </div>
      {/* cv in the house baby */}
      <div className='flex flex-col  text-2xl md:text-xl text-white lg:w-full lg:mt-4'>
        <div className='pb-3  capitalize w-full border-b-2 border-abouttext'>name: hardik chopra</div>
        <div className='pb-3 pt-3 capitalize w-full border-b-2 border-abouttext'> email: <span className='text-red normal-case'>hardikchopra70@gmail.com</span> </div>
        <div className='pb-3 pt-3 capitalize w-full border-b-2 border-abouttext' >age: 20</div>
        <div className='pb-3 pt-3 capitalize w-full border-b-2 border-abouttext'>from: ludhiana,punjab</div>
        <Cvbtn value={true}/>
      </div>
     </div>

      {/* numbers in the house baby  bg-amber-950 */}
      {/* <div className='flex w-3/4 ml-56  justify-center mb-6 mt-5  items-baseline text-abouttext  flex-wrap lg:w-screen lg:ml-0'>
        <div className=' flex flex-col items-center justify-evenly text-6xl lg:text-3xl  border-r-2 border-abouttext  w-1/4 h-30 '>
          <p w-full text-center>10+</p>
          <p className='text-base text-center w-full'>years of experience</p>
        </div>
        <div className='text-6xl flex flex-col items-baseline justify-evenly lg:text-3xl   border-r-2 border-abouttext w-1/4 h-30 '>
          <p className='w-full text-center'>250+</p>
          <p className=' text-base text-center w-full'>projects</p>
        </div>
        <div className=' flex   justify-center items-center flex-col text-6xl lg:text-3xl  border-r-2 border-abouttext w-1/4   '>
          <p className='w-full  text-center'>650</p>
          <p className='mt-2 w-full text-center text-base'>clients</p>
        </div>
        <div className='text-6xl flex flex-col items-center justify-center  lg:text-3xl    w-1/4  '>
          <p className='w-full text-center'>38</p>
          <p className='mt-2 w-full text-center text-base'>certificates</p>
        </div>
      </div> */}
    </div>
  )
}
 
export default About
